import { render, staticRenderFns } from "./Franquia.vue?vue&type=template&id=1df031bb&scoped=true"
import script from "./Franquia.vue?vue&type=script&lang=js"
export * from "./Franquia.vue?vue&type=script&lang=js"
import style0 from "./Franquia.vue?vue&type=style&index=0&id=1df031bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df031bb",
  null
  
)

export default component.exports